"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Conditions(_ref) {
  var i18n = _ref.i18n,
      notes = _ref.notes,
      cancelpolicies = _ref.cancelpolicies;

  return _react2.default.createElement(
    "div",
    null,
    notes.length > 0 ? _react2.default.createElement(
      "div",
      { className: "please-note" },
      _react2.default.createElement(
        "div",
        { className: "title-box" },
        _react2.default.createElement(
          "h3",
          null,
          i18n.hotelInformation.pleaseNote
        )
      ),
      _react2.default.createElement(
        "div",
        { className: "content-box" },
        notes.map(function (item, index) {
          return _react2.default.createElement(
            "p",
            { key: index },
            item.note
          );
        })
      )
    ) : null,
    cancelpolicies.policies ? _react2.default.createElement(
      "div",
      { className: "cancel-policy" },
      _react2.default.createElement(
        "div",
        { className: "title-box" },
        _react2.default.createElement(
          "h3",
          null,
          i18n.hotelInformation.cancelPolicy
        )
      ),
      _react2.default.createElement(
        "div",
        { className: "content-box" },
        _react2.default.createElement("p", { dangerouslySetInnerHTML: { __html: cancelpolicies.description } }),
        _react2.default.createElement(
          "ul",
          null,
          cancelpolicies.policies.length > 0 && cancelpolicies.policies.map(function (policy) {
            return _react2.default.createElement(
              "li",
              { key: policy.lead },
              _react2.default.createElement(
                "dl",
                null,
                _react2.default.createElement(
                  "dt",
                  null,
                  policy.lead
                ),
                _react2.default.createElement(
                  "dd",
                  null,
                  policy.cancellation
                )
              )
            );
          })
        )
      )
    ) : null
  );
} // Conditions

Conditions.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  notes: _react.PropTypes.array.isRequired,
  cancelpolicies: _react.PropTypes.object.isRequired
};

exports.default = Conditions;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/Conditions.js
// module id = 1196
// module chunks = 0